// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageBox_wrapper__3KvsX","container":"ImageBox_container__5i++-"};